import { useMutation } from "@/compat/reactQuery";
import shareGroupService from "../../services/shareGroupService";

const useSaveShareGroup = () => useMutation(shareGroupService.saveShareGroup);

export default useSaveShareGroup;
